import { useEffect } from 'react';
import { WebSocketChannelClient } from '../../utils/WebSocketChannelClient';

function useWebSocketSubscription(client: WebSocketChannelClient, channelId: string, handler: (s: string) => void, dependencies?: any[]) {
  useEffect(() => {
    if (channelId) {
      client.subscribe(channelId, handler);

      return () => {
        client.unsubscribe(channelId);
      };
    }
  }, [client, channelId]);

  useEffect(() => {
    if (channelId) {
      client.updateHandler(channelId, handler);
    }
  }, [client, channelId, handler, ...(dependencies || [])]);
}

export default useWebSocketSubscription;
